import {Nav} from './components/nav'
import './pages/home.imba'
import './pages/article.imba'
import './pages/user.imba'

tag app
	<self>
		<Nav>
		<home-page route="/$">
		<home-page route="/news/:page">
		<home-page route="/newest/:page" type="newest">
		<home-page route="/show/:page" type="show">
		<home-page route="/ask/:page" type="ask">
		<home-page route="/jobs/:page" type="jobs">
		<article-page route="/item/:id">
		<user-page route="/user/:id">

imba.mount <app>